import { render, staticRenderFns } from "./ViewPendingMembers.vue?vue&type=template&id=24ac9af0&scoped=true"
import script from "./ViewPendingMembers.vue?vue&type=script&lang=js"
export * from "./ViewPendingMembers.vue?vue&type=script&lang=js"
import style0 from "./ViewPendingMembers.vue?vue&type=style&index=0&id=24ac9af0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ac9af0",
  null
  
)

export default component.exports